import {  
    getFirestore, 
    doc,
    deleteDoc,
    updateDoc,
    increment
} from "firebase/firestore";
const removeRewardsHistory = async function(reward_id, id) {

    let db = getFirestore();
    const docRef = doc(db, "wellness_rewards", reward_id, "redeem_history", id);
    await deleteDoc(docRef)

    await updateDoc(doc(db, "wellness_rewards", reward_id), {
        redeemCount: increment(-1)
    });
};

export default removeRewardsHistory;
